let dashboard = {
    _name: 'CSidebarNavItem',
    trans: 'dashboard',
    to: { name: 'dashboard' },
    icon: 'tachometer-alt',
}

// let promotions = {
//     _name: 'CSidebarNavDropdown',
//     trans: 'promotion.plural',
//     to: { name: 'promotions' },
//     icon: 'ad',
//     rules: {
//         promotion: ['read_any', 'read_group', 'read_own'],
//     },
//     items: [
//         {
//             trans: 'promotion.types.all',
//             to: { name: 'promotions' },
//         },
//         {
//             trans: 'promotion.types_plural.banner',
//             to: { name: 'promotions.types.banners' },
//         },
//         {
//             trans: 'promotion.types_plural.link',
//             to: { name: 'promotions.types.links' },
//         },
//     ]
// }


let banners = {
    _name: 'CSidebarNavItem',
    trans: 'promotion.types_plural.banner',
    to: { name: 'promotions.types.banners' },
    icon: 'ad',
    rules: {
        promotion: ['read_any', 'read_group', 'read_own', 'write_own'],
    },
}

let contactUs = {
    _name: 'CSidebarNavItem',
    trans: 'contact_us._',
    to: { name: 'contact_us' },
    icon: 'address-book',
    rules: {
        user: ['read_any', 'read_group'],
    },
}

let publishers = {
    _name: 'CSidebarNavItem',
    trans: 'publisher.plural',
    to: { name: 'publishers.stores' },
    icon: 'face-smile',
    rules: {
        publisher: ['read_any', 'read_group', 'read_own'],
    },
}

let conversions = {
    _name: 'CSidebarNavItem',
    trans: 'conversion.plural',
    to: { name: 'conversions' },
    icon: 'exchange-alt',
    rules: {
        conversion: ['write_any', 'write_group', 'write_own'],
    },
}

let commissions = {
    _name: 'CSidebarNavItem',
    trans: 'commission.plural',
    to: {name: 'v2.commissions'},
    icon: 'percentage',
    rules: {
        commission: ['write_own']
    },
}


let buys = {
    _name: 'CSidebarNavItem',
    trans: 'sales_and_leads',
    to: { name: 'conversions' },
    icon: 'exchange-alt',
    rules: {
        'store.join': ['execute_any'],
    },
}

let transactions = {
    _name: 'CSidebarNavItem',
    trans: 'transaction.transactions',
    to: { name: 'transactions' },
    icon: 'wallet',
    rules: {
        'store.join': ['execute_any'],
    },
}

let transactionsDropdown = {
    _name: 'CSidebarNavDropdown',
    trans: 'transaction.financial',
    route: '/transactions',
    icon: 'wallet',
    rules: {
        financial: ['write_any', 'write_group', 'write_own']
    },
    items: [
        {
            trans: 'transaction.transactions',
            to: { name: 'transactions' },
            rules: {
                transaction: ['read_any', 'read_group', 'read_own']
            },
        },
        {
            trans: 'transaction.charge',
            to: { name: 'transactions.charge' },
            rules: {
                financial: ['write_any', 'write_group', 'write_own']
            }
        },
        {
            trans: 'transaction.wallet',
            to: { name: 'transactions.wallet' },
            rules: {
                wallet: ['read_any']
            }
        },
        {
            trans: 'transaction.checkout_list',
            to: { name: 'transactions.checkout_list' },
            rules: {
                financial: ['write_any']
            }
        },
        {
            trans: 'transaction.negative_stores_list',
            to: { name: 'transactions.negative_stores_list' },
            rules: {
                financial: ['write_any']
            }
        },
        {
            trans: 'invoice.plural',
            to: { name: 'invoices' },
            rules: {
                financial: ['write_any', 'write_group', 'write_own']
            }
        },
        // {
        //     trans: 'transaction.checkout_request',
        //     to: {name: 'transactions.checkout_request'},
        //     rules: {
        //         transaction: ['checkout_request']
        //     }
        // },
        // {
        //     trans: 'transaction.checkout_requests_reports',
        //     to: {name: 'transactions.checkout_requests_reports'},
        //     rules: {
        //         transaction: ['checkout_requests_reports']
        //     },
        // },
    ]
}

let users = {
    _name: 'CSidebarNavItem',
    trans: 'user.plural',
    to: { name: 'users' },
    icon: 'user',
    rules: {
        user: ['read_any', 'read_group'],
    },
}

let agreements = {
    _name: 'CSidebarNavItem',
    trans: 'agreement.plural',
    to: { name: 'agreements' },
    icon: 'file-contract',
    rules: {
        agreement: ['read_any', 'read_group'],
    },
}

// let roles = {
//     _name: 'CSidebarNavItem',
//     trans: 'role.plural',
//     to: {name: 'roles'},
//     icon: 'user-shield',
//     rules: {
//         role: ['read_any', 'read_group', 'read_own'],
//     }
// }

let reports = {
    _name: 'CSidebarNavDropdown',
    trans: 'report.plural',
    route: '/reports',
    icon: 'chart-bar',
    items: [
        {
            trans: 'transaction.plural',
            to: {name: 'transactions.reports'},
            rules: {
                'store.join': ['execute_any']
            },
        },
        {
            trans: 'click.plural',
            to: {name: 'reports.clicks'},
            rules: {
                link: ['execute_any', 'execute_group', 'execute_own'],
            },
        },
    ]
}

let media = {
    _name: 'CSidebarNavItem',
    trans: 'media.plural',
    to: { name: 'media' },
    icon: 'newspaper',
    rules: {
        media: ['read_any', 'read_group', 'read_own'],
    },
}

let products = {
    _name: 'CSidebarNavItem',
    trans: 'product.plural',
    to: { name: 'products' },
    icon: 'shopping-bag',
    rules: {
        product: ['read_any', 'read_group', 'read_own'],
    },
}

let serviceManagement = {
    _name: 'CSidebarNavItem',
    trans: 'service_management.plural',
    href: `${process.env.VUE_APP_BASE_OAUTH2}/panel/services`,
    // target: '_blank',
    icon: 'th-large',
}

let links = {
    _name: 'CSidebarNavItem',
    trans: 'link.plural',
    to: { name: 'links' },
    icon: 'link',
    rules: {
        link: ['read_any', 'read_group', 'read_own'],
    },
}

// let pageBuilder = {
//     _name: 'CSidebarNavItem',
//     trans: 'pageBuilder.page',
//     to: { name: 'pageBuilder' },
//     icon: 'clipboard-list',
//     rules: {
//         page_builder: ['read_any', 'read_group', 'read_own'],
//     },
// }

let stores = {
    _name: 'CSidebarNavItem',
    trans: 'store.plural',
    to: { name: 'stores' },
    icon: 'store',
    rules: {
        store: ['write_any', 'write_group'],
    },
}

let myStore = {
    _name: 'CSidebarNavItem',
    trans: 'store.my',
    to: { name: 'stores.my' },
    icon: 'store',
    rules: {
        store: ['write_own'],
    },
}

let storesDropdown = {
    _name: 'CSidebarNavDropdown',
    trans: 'store.plural',
    icon: 'store',
    rules: {
        'store.join': ['execute_any'],
    },
    items: [
        {
            trans: 'store.all',
            to: { name: 'stores' },
        },
        {
            trans: 'store.collaborating',
            to: { name: 'stores.collaborating' },
        },
        {
            trans: 'store.pending',
            to: { name: 'stores.pending' },
        },
    ]
}

let shortLinks = {
    _name: 'CSidebarNavItem',
    trans: 'short_link._',
    to: { name: 'short_links' },
    icon: 'link',
    rules: {
        user: ['read_any', 'read_group'],
    },
}

// let coupons = {
//     _name: 'CSidebarNavDropdown',
//     trans: 'coupon.plural',
//     to: { name: 'coupons' },
//     icon: 'tag',
//     rules: {
//         coupon: ['read_any', 'read_group', 'read_own'],
//     },
//     items: [
//         {
//             trans: 'coupon.methods.all',
//             to: { name: 'coupons' },
//         },
//         {
//             trans: 'coupon.methods_plural.general',
//             to: { name: 'coupons.methods.general' },
//         },
//         {
//             trans: 'coupon.methods_plural.dedicated',
//             to: { name: 'coupons.methods.dedicated' },
//         },
//     ]
// }

let coupons = {
    _name: 'CSidebarNavItem',
    trans: 'coupon.plural',
    to: { name: 'coupons' },
    icon: 'tag',
    rules: {
        coupon: ['read_any', 'read_group', 'read_own'],
    },
}

let conversations = {
    _name: 'CSidebarNavItem',
    trans: 'conversation.plural',
    to: { name: 'conversations' },
    icon: 'comment',
    rules: {
        conversation: ['read_any', 'read_group', 'read_own'],
    },
}

// let notifications = {
//     _name: 'CSidebarNavItem',
//     trans: 'notification.send',
//     to: { name: 'notifications.send' },
//     icon: 'bell',
//     rules: {
//         notification: ['execute_any'],
//     },
// }

let support = {
    _name: 'CSidebarNavItem',
    trans: 'ticket.plural',
    to: { name: 'tickets' },
    icon: 'headset',
    rules: {
        ticket: ['read_any', 'read_group', 'read_own']
    },
}

let account = {
    _name: 'CSidebarNavItem',
    trans: 'user.account',
    to: { name: 'account.edit' },
    icon: 'user',
}

let logout = {
    _name: 'CSidebarNavItem',
    trans: 'logout',
    href: process.env.VUE_APP_BASE_OAUTH2 + '/logout',
    icon: 'sign-out-alt',
}

let campaigns = {
    _name: 'CSidebarNavItem',
    trans: 'campaign.plural',
    to: { name: 'campaigns' },
    icon: 'bullseye',
    rules: {
        campaign: ['read_any', 'read_group', 'read_own'],
    },
}

let tags = {
    _name: 'CSidebarNavItem',
    trans: 'tag.plural',
    to: { name: 'tags' },
    icon: 'tag',
    rules: {
        tag: ['read_any', 'read_group', 'read_own'],
    },
}


export default [{
    _name: 'CSidebarNav',
    _children: [
        dashboard,
        stores,
        myStore,
        storesDropdown,
        links,
        // pageBuilder,
        // promotions,
        banners,
        commissions,
        coupons,
        media,
        conversations,
        products,
        publishers,
        campaigns,
        conversions,
        buys,
        users,
        agreements,
        shortLinks,
        // roles,
        reports,
        // notifications,
        transactions,
        transactionsDropdown,
        support,
        contactUs,
        tags,
        account,
        serviceManagement,
        logout,
    ]
}]